import gql from 'graphql-tag';

export const PROCESS_EXPORT_REPORTS_DATA = gql`
  mutation ProcessExportReportsData($params: ReportInput!) {
    processExportReportsData(params: $params) {
      uuid
    }
  }
`;

export default PROCESS_EXPORT_REPORTS_DATA;
